var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-5" }, [
    _c("div", { staticClass: "flex flex-col" }, [
      _c(
        "div",
        {
          staticClass:
            "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        },
        [
          _vm.messageLogs.docs && _vm.messageLogs.docs.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                },
                [
                  _c("table", { staticClass: "min-w-full" }, [
                    _vm._m(0),
                    _c(
                      "tbody",
                      { staticClass: "bg-white" },
                      _vm._l(_vm.messageLogs.docs, function(log) {
                        return _c(
                          "tr",
                          {
                            key: log.id,
                            staticClass:
                              "grid grid-cols-2 grid-flow-row md:table-row"
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                              },
                              [_vm._v(" " + _vm._s(log.phoneNumber) + " ")]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                              },
                              [_vm._v(" " + _vm._s(log.checkoutId) + " ")]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                              },
                              [
                                _vm._v(" " + _vm._s(log.messageStatus) + " "),
                                log.channel === "sms"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                                      },
                                      [
                                        _vm._v(
                                          " sent as " +
                                            _vm._s(log.channel) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                              },
                              [_vm._v(" " + _vm._s(log.totalPrice) + " ")]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("dateFilter")(log.createdAt)
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap"
                              },
                              [_vm._v(" " + _vm._s(log.body) + " ")]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _c("Pagination", {
                    attrs: { page: _vm.messageLogs },
                    on: { pageChanged: _vm.loadPage }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.isLoading &&
          _vm.messageLogs.docs &&
          _vm.messageLogs.docs.length === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                },
                [
                  _vm._v(
                    " You don't have any message logs right now. We will be listing them here as soon as we sent a message. "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "hidden md:table-row" }, [
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Phone Number ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" checkoutId ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Message Status ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Total ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" DATE ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Whatsapp message ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }